import de_DE from './de_DE.json';
import en_US from './en_US.json';
import ja_JP from './ja_JP.json';
import ko_KR from './ko_KR.json';
import zh_CN from './zh_CN.json';

export const messages = {
    'de-DE': de_DE,
    'en-US': en_US,
    'ja-JP': ja_JP,
    'ko-KR': ko_KR,
    'zh-CN': zh_CN,
};
